import React, { useState, FormEvent, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Checkbox, Collapse, HTMLSelect, HTMLTable, ControlGroup, Classes, MenuItem, Alert } from "@blueprintjs/core";

import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { Account, Currency } from './Types'

interface AccountViewProps {
    ac: Account,
    baseUrl?: string,
    token?: string | null,
    onEdit?: () => void,
    onNew?: () => void,
    onDelete?: (ac: Account) => void,
}

function AccountView({ ac = {} as Account, baseUrl = "", token = "", onEdit = () => { }, onNew = () => { }, onDelete = () => {} }: AccountViewProps) {
    const { t, i18n } = useTranslation();
    const [isOpenDelete, setIsOpenDelete] = useState(false)

    if (!("acCode" in ac)) return null

    return (
        <div>
            {/*
            <Dialog icon="help" isOpen={isOpenDelete} canEscapeKeyClose={true} canOutsideClickClose={true} title="AC3x" onClose={() => setIsOpenDelete(false)}>
                <div className="DialogBody">
                    <div className="Spacing-V-16" />
                    <p>Delete account {ac.acCode}?</p>
                    <div className="Row-4">
                        <Button className="Col-3-1" icon="cross" onClick={() => setIsOpenDelete(false)}>No</Button>
                        <Button className="Col-4-1" icon="tick" intent="danger" onClick={() => {onDelete(ac); setIsOpenDelete(false)}}>DELETE</Button>
                    </div>
                </div>
            </Dialog>
            */}
            <Alert icon="trash" intent="danger" confirmButtonText={t('button_delete')} isOpen={isOpenDelete} onConfirm={() => {onDelete(ac); setIsOpenDelete(false)}} onCancel={() => setIsOpenDelete(false)} cancelButtonText={t('button_no')} canEscapeKeyCancel={true} canOutsideClickCancel={true}>
                <p>{t('confirm_delete_account', {ac})}</p>
            </Alert>
            <div className="Row">
                <Button className="Col-1-1" icon="add" onClick={() => onNew()}>{t('new')}</Button>
                <Button className="Col-2-1" icon="edit" onClick={() => onEdit()}>{t('edit')}</Button>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('account')}>
                    <InputGroup readOnly value={ac.acCode} />
                </FormGroup>
                <FormGroup className="Col-2-3" label={t('account_name')}>
                    <InputGroup readOnly value={ac.acName1} />
                    {/*<InputGroup readOnly value={ac.acName2} />*/}
                </FormGroup>
            </div>
            {/*
            <div className="Row">
                <FormGroup className="Col-1-1" label="CCY">
                    <InputGroup readOnly value={ac.ccyCode} />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('account_type')}>
                    <InputGroup readOnly value={t(utils.acTypeName(ac.acType))} />
                </FormGroup>
                {/*
                <FormGroup className="Col-2-1" label="Is General">
                    <InputGroup readOnly type="checkbox" checked={ac.isGeneral} />
                </FormGroup>
                */}
                <Checkbox className="Col-2-1 Checkbox-LabeledFormGroup" label={t('is_general')} checked={(ac.isGeneral === "Y")} />
                <FormGroup className="Col-3-1" label={t('parent')}>
                    <InputGroup readOnly value={ac.general} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('level')}>
                    <InputGroup readOnly value={ac.level.toString()} />
                </FormGroup>
                <FormGroup className="Col-5-1" label={t('cash_flow_type')}>
                    <InputGroup readOnly value={t(utils.cashFlowTypeName(ac.cashFlowType))} />
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <Button className="Col-1-1" icon="trash" onClick={() => setIsOpenDelete(!isOpenDelete)}>{t('delete')}</Button>
            </div>
        </div>
    )
}

interface AccountEditProps {
    ac?: Account,
    ccyList?: Currency[],
    isNew?: boolean,
    onSave: (ac: Account, saveAndNew: boolean) => Promise<boolean>,
    onCancel: () => void;
}

// onChange={utils.handleStringChange(s => setAc(prevState => Object.assign(prevState, {acName1: s})))}
function AccountEdit({ ac = {} as Account, ccyList = [] as Currency[], isNew = false, onSave, onCancel }: AccountEditProps) {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue } = useForm<Account>()

    useEffect(() => {
        console.log("useEffect []")
        // Call reset to set default values if ac is passed
        if ("acCode" in ac) {
            console.log("reset(ac)")
            if (isNew) {
                reset({...ac, ...{acCode: "", acName1: ""}})
            } else {
                reset(ac)
            }
        }
    }, [])
    //}, [ac, reset])

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        register({ name: "ccyCode" })
        register({ name: "acType" })
        register({ name: "cashFlowType" })
    }, [register])

    if (!isNew && !("acCode" in ac)) return null

    const onSubmit = async (data: Account) => {
        //console.log("onsubmit called", data)
        //onSave(data)
        let saveAndNew = isNew
        if (await onSave(data, saveAndNew) && saveAndNew) {
            //reset({acCode: "", acName1: ""})
            setValue("acCode", "")
            setValue("acName1", "")
            document.getElementsByName(`acCode`)[0].focus()
        }
    }

    const ccyRenderer: ItemRenderer<Currency> = (ccy, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${ccy.ccyName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={ccy.ccyCode}
                key={ccy.ccyCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const ccyPredicate: ItemPredicate<Currency> = (query, ccy, _index, exactMatch) => {
        const normalizedText = `${ccy.ccyCode} - ${ccy.ccyName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const ccyValueRenderer = (ccy: Currency) => {
        return ccy.ccyCode
    }

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>{t('cancel')}</Button>
                <Button className="Col-2-1" icon={isNew?"add":"tick"} onClick={handleSubmit(onSubmit)}>{t('save')}</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ac)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('account')} labelFor="inputAcCode">
                    <InputGroup readOnly={!isNew} id="inputAcCode" name="acCode" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-2-3" label={t('account_name')} labelFor="inputAcName1">
                    <InputGroup id="inputAcName1" name="acName1" inputRef={register} />
                    {/*<InputGroup id="inputAcName2" name="acName2" inputRef={register} />*/}
                </FormGroup>
            </div>
            {/*
            <div className="Row">
                <FormGroup className="Col-1-1" label="CCY" labelFor="inputCcyCode">
                    <Suggest
                        inputProps={{ placeholder: "" }}
                        defaultSelectedItem={ccyList.find((ccy) => ccy.ccyCode === ac.ccyCode)}
                        items={ccyList}
                        itemRenderer={ccyRenderer}
                        itemPredicate={ccyPredicate}
                        inputValueRenderer={ccyValueRenderer}
                        onItemSelect={(ac) => { setValue("ccyCode", ac.ccyCode) }}
                    />
                </FormGroup>
            </div>
            */}
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('account_type')} labelFor="inputAcType">
                    {/*<InputGroup id="inputAcType" name="acType" inputRef={register} />*/}
                    <HTMLSelect fill defaultValue={ac.acType} onChange={(e) => setValue("acType", e.currentTarget.value)}>
                        <option value="" selected>{t('choose_an_item')}</option>
                        <option value="A">{t('asset')}</option>
                        <option value="L">{t('liability')}</option>
                        <option value="C">{t('capital')}</option>
                        <option value="I">{t('revenue')}</option>
                        <option value="E">{t('expense')}</option>
                    </HTMLSelect>
                </FormGroup>
                <label className="bp3-control bp3-checkbox Checkbox-LabeledFormGroup">
                    <input id="inputIsGeneral" name="isGeneral" type="checkbox" ref={register} />
                    <span className="bp3-control-indicator"></span>
                    {t('is_general')}
                </label>
                {/*
                <FormGroup className="Col-2-1" label="Is General" labelFor="inputIsGeneral">
                    <input className="bp3-control bp3-checkbox" id="inputIsGeneral" name="isGeneral" type="checkbox" ref={register} />
                </FormGroup>

                <FormGroup className="Col-2-1" label="Is General" labelFor="inputIsGeneral">
                    <InputGroup id="inputIsGeneral" name="isGeneral" type="checkbox" inputRef={register} />
                </FormGroup>
                <Checkbox className="Col-2-1 Checkbox-LabeledFormGroup" name="isGeneral" label="Is General" defaultChecked={ac.isGeneral} value="Y" inputRef={register} />
                */}
                <FormGroup className="Col-3-1" label={t('parent')} labelFor="inputGeneral">
                    <InputGroup id="inputGeneral" name="general" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('level')} labelFor="inputLevel">
                    <InputGroup id="inputLevel" name="level" type="number" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-5-1" label={t('cash_flow_type')} labelFor="inputCashFlowType">
                    {/*<InputGroup id="inputCashFlowType" name="cashFlowType" inputRef={register} />*/}
                    <HTMLSelect fill defaultValue={ac.cashFlowType} onChange={(e) => setValue("cashFlowType", e.currentTarget.value)}>
                        <option value="" selected>{t('none')}</option>
                        <option value="O">{t('operating')}</option>
                        <option value="I">{t('investing')}</option>
                        <option value="F">{t('financial')}</option>
                        <option value="C">{t('cash')}</option>
                    </HTMLSelect>
                </FormGroup>
            </div>
        </form>
    )
}

interface AccountMainProps {
    svc: AxiosInstance
}

function AccountMain({ svc }: AccountMainProps) {
    let { tabId: defaultTabId = "list" }: { tabId: string } = useParams()
    const { t, i18n } = useTranslation();
    const history = useHistory()

    const [data, setData] = useState([] as Account[])

    const [ccyList, setCcyList] = useState([] as Currency[])

    const [searchKey, setSearchKey] = useState("acCode")
    const [searchValue, setSearchValue] = useState("")

    const [showFilters, setShowFilters] = useState(true)

    const [searchName, setSearchName] = useState("")
    const [searchType, setSearchType] = useState("")
    const [searchCcy, setSearchCcy] = useState("")

    const [searchLimit, setSearchLimit] = useState(0)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState(defaultTabId) //useState("list")
    const [lastTabId, setLastTabId] = useState(defaultTabId) //useState("list")
    const [currentAc, setCurrentAc] = useState({} as Account)

    const [currentMode, setCurrentMode] = useState("show")

    useEffect(() => {
        setSelectedTabId(defaultTabId)
    }, [defaultTabId])

    const changeTab = (tabId: string) => {
        history.push(`/accounts/${tabId}`)
        setSelectedTabId(tabId)
    }

    useEffect(() => {
        (async () => {
            try {
                const res = await svc.post('/currencylist',
                    {
                        by: "ccyCode",
                        start: "",
                        limit: 0,
                        backward: false,
                        filters: {
                            ccyCode: "",
                        }
                    });
                setCcyList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }

            refreshAccounts()
        })()
    }, [svc])

    useEffect(() => {
        if (data.length > 0) {
            let i = 0;
            if ("acCode" in currentAc) {
                i = data.findIndex(ac => ac.acCode === currentAc.acCode)
            }
            setCurrentAc(i > 0 ? data[i] : data[0])
        }
    }, [data])

    const refreshAccounts = async () => {
        try {
            const res = await svc.post('/accountlist',
                {
                    by: searchKey,
                    start: searchValue,
                    limit: searchLimit,
                    backward: searchBackward,
                    filters: {
                        acName: searchName,
                        acType: searchType,
                        ccyCode: searchCcy
                    }
                });

            setData(res.data.data)
            if (res.data.data.length === 0) {
                utils.showError(t('no_record'))
            }
            /*
            if (res.data.data.length > 0) {
                setCurrentAc(res.data.data[0])
            } else {
                utils.showError(t('no_record'))
            }
            */
            //changeTab("list")
        } catch (error) {
            utils.showError(error)
        }    
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        refreshAccounts()
        /*
        try {
            const res = await svc.post('/accountlist',
                {
                    by: searchKey,
                    start: searchValue,
                    limit: searchLimit,
                    backward: searchBackward,
                    filters: {
                        acName: searchName,
                        acType: searchType,
                        ccyCode: searchCcy
                    }
                });

            setData(res.data.data)
            if (res.data.data.length > 0) {
                setCurrentAc(res.data.data[0])
            } else {
                utils.showError(t('no_record'))
            }
            //changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
        */
    }

    const editOnSave = async (ac: Account) => {
        try {
            const res = await svc.post('/accountupdate', ac)
            utils.showSuccess(t('saved', {key: res.data.data.acCode}))
            for (let i = 0; i < data.length; i++) {
                if (data[i].acCode === res.data.data.acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    //setCurrentAc(ac)
                    break
                }
            }
            setCurrentAc(res.data.data)
            setCurrentMode("show")
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const newOnSave = async (ac: Account, saveAndNew: boolean = false) => {
        try {
            const res = await svc.post('/accountadd', ac)
            utils.showSuccess(t('saved', {key: res.data.data.acCode}))
            refreshAccounts()
            /*
            for (let i = 0; i < data.length; i++) {
                if (data[i].acCode === res.data.data.acCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            */
            setCurrentAc(res.data.data)
            if (!saveAndNew) setCurrentMode("show")
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const viewOnDelete = async (ac: Account) => {
        try {
            //console.log("deleting account:", vch)
            const res = await svc.post('/accountdelete', ac)
            utils.showSuccess(t('deleted'))
            setData(data.filter(ac => !(ac.acCode === res.data.acCode)))
            setCurrentAc({} as Account)
            changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    // currentMode = show
    let detail = <AccountView ac={currentAc} baseUrl={svc.defaults.baseURL} token={localStorage.getItem('token')} onEdit={() => setCurrentMode("edit")} onNew={() => {setLastTabId(selectedTabId); setCurrentMode("new")}} onDelete={viewOnDelete}></AccountView>
    switch (currentMode) {
        case "edit":
            detail = <AccountEdit ac={currentAc} ccyList={ccyList} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></AccountEdit>
            break
        case "new":
            detail = <AccountEdit ccyList={ccyList} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); changeTab(lastTabId) }}></AccountEdit>
            break
    }

    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setLastTabId(selectedTabId); setCurrentMode("new"); changeTab("detail") }}>{t('new')}</Button>
            <AnchorButton className="Col-2-1" icon="download" target="_blank" href={`${svc.defaults.baseURL}/downloadcoa`}>Excel</AnchorButton>
        </div>
        <div className="Spacing-V-16" />
        <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-ACCode">{t('account')}</th>
                    <th className="TCol-ACName">{t('account_name')}</th>
                    <th className="TCol-ACType">{t('account_type')}</th>
                    <th className="TCol-ACFlag">{t('is_general')}</th>
                    <th className="TCol-ACCode">{t('parent')}</th>
                    <th className="TCol-ACFlag">{t('level')}</th>
                    <th className="TCol-ACType">{t('cash_flow_type')}</th>
                </tr>
            </thead>
            <tbody>
                {data.map((ac, i) =>
                    <tr key={i} onDoubleClick={() => { changeTab("detail") }}>
                        <td className="TCol-ACCode" onClick={() => { setCurrentAc(ac) }}>{ac.acCode}</td>
                        <td className="TCol-ACName" onClick={() => { setCurrentAc(ac) }}> <div className={`Indent-${ac.level-1}`}>{ac.acName1+ac.acName2}</div></td>
                        <td className="TCol-ACType" onClick={() => { setCurrentAc(ac) }}>{t(utils.acTypeName(ac.acType))}</td>
                        <td className="TCol-ACFlag" onClick={() => { setCurrentAc(ac) }}>{ac.isGeneral}</td>
                        <td className="TCol-ACCode" onClick={() => { setCurrentAc(ac) }}>{ac.general}</td>
                        <td className="TCol-ACFlag" onClick={() => { setCurrentAc(ac) }}>{ac.level}</td>
                        <td className="TCol-ACType" onClick={() => { setCurrentAc(ac) }}>{t(utils.cashFlowTypeName(ac.cashFlowType))}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('chart_of_accounts')}</div>
            <div className="Spacing-V-16"></div>
            <form onSubmit={onSubmit}>
                <div className="Row">
                    <FormGroup className="Col-1-3" label={t('search')} labelFor="inputSearchValue">
                        <ControlGroup fill>
                            <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                <option value="acCode">{t('account')}</option>
                                <option value="acName">{t('account_name')}</option>
                                <option value="_recordNo">Record No.</option>
                            </HTMLSelect>
                            <InputGroup
                                id="inputSearchValue"
                                placeholder={t('search')}
                                value={searchValue}
                                onChange={utils.handleStringChange(s => setSearchValue(s))}
                                leftIcon="search"
                                rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                            />
                        </ControlGroup>
                    </FormGroup>
                    {/*<Checkbox className="Col-4-1 Checkbox-LabeledFormGroup" label="Backward" onChange={utils.handleBooleanChange(v => setSearchBackward(v))} />*/}
                    {/*<Button className="Col-5-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>*/}
                </div>
                <Collapse isOpen={showFilters}>
                    <div className="Row">
                        <FormGroup className="Col-1-3" label={t('account_name')} labelFor="searchIdNo">
                            <InputGroup id="searchName" value={searchName} onChange={utils.handleStringChange(s => setSearchName(s))} />
                        </FormGroup>
                        {/*
                        <FormGroup className="Col-2-1" label="Ccy" labelFor="searchCcy">
                            <InputGroup id="searchCcy" value={searchCcy} onChange={utils.handleStringChange(s => setSearchCcy(s))} />
                        </FormGroup>
                        */}
                        {/*
                        <div className="Col-4-2 Col-H">
                            <FormGroup label="Type" labelFor="searchType">
                                <InputGroup className="Input-XS" id="searchType" value={searchType} onChange={utils.handleStringChange(s => setSearchType(s))} />
                            </FormGroup>
                            <FormGroup label="Limit" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup>
                        </div>
                        */}
                        <FormGroup className="Col-4-1" label={t('account_type')} labelFor="searchType">
                            <HTMLSelect fill defaultValue={searchType} onChange={(e) => setSearchType(e.currentTarget.value)}>
                                <option value="">{t('any')}</option>
                                <option value="A">{t('asset')}</option>
                                <option value="L">{t('liability')}</option>
                                <option value="C">{t('capital')}</option>
                                <option value="I">{t('revenue')}</option>
                                <option value="E">{t('expense')}</option>
                            </HTMLSelect>
                        </FormGroup>
                    </div>
                </Collapse>
            </form>
            <Tabs onChange={(newTabId) => changeTab(newTabId as string)} selectedTabId={selectedTabId}>
                <Tab id="list" title={t('list')} panel={list} />
                <Tab id="detail" title={t('detail')} panel={detail} />
            </Tabs>
        </>
    );
}

export default AccountMain